import './OkulyonetimDersFilter.scss';

import {Checkbox, Input} from 'antd';
import React, {useState} from 'react';

import {OkulyonetimOtherFilterType} from './type';

const {Search} = Input;

const OkulyonetimDersFilter: React.FC<OkulyonetimOtherFilterType> = (props) => {
    const {title, searchbar, options, onChange, checkedTempKeys} = props;

    const [selectedOptions, setSelectedOptions] = useState<string[]>(
        options.filter((option) => option.isSelected === true).map((option) => option.value!) // Başlangıçta seçili olanları ayarla
    );

    const handleCheckboxChange = (value: string) => {
        setSelectedOptions((prevSelectedOptions) => {
            const updatedSelectedOptions = prevSelectedOptions.includes(value)
                ? prevSelectedOptions.filter((option) => option !== value) // Seçiliyse kaldır
                : [...prevSelectedOptions, value]; // Seçili değilse ekle
            if (selectedOptions) {
                console.log(selectedOptions)
            }
            // Güncel seçili değerleri dışarı aktar
            onChange?.([...updatedSelectedOptions]);

            return updatedSelectedOptions;
        });
    };
    return (
        <div className="db-okulyonetim-other-filter">
            <div className="okulyonetim-other-filter">
                <div className="okulyonetim-other-filter-title">{title}</div>
                {searchbar && (
                    <div className="okulyonetim-other-filter-search">
                        <Search/>
                    </div>
                )}
                <div className="okulyonetim-other-filter-options">
                    {options.map((option, index) => (
                        <div key={index}>
                            <Checkbox
                                checked={checkedTempKeys.includes(option.value!)} // `selectedOptions` içinde olup olmadığını kontrol et
                                onChange={() => handleCheckboxChange(option.value!)} // Seçimi değiştir
                            >
                                {option.title} {option.count}
                            </Checkbox>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default OkulyonetimDersFilter;
